import type { ReactNode } from 'react'
import { Link as RouterLink } from 'react-router'
import { cx } from '../cx'
import s from './Link.module.css'

/**
 * A link to another page of the app (no reload), or out of it (`href`, opens in a new tab). `block` makes a whole
 * row a link, for lists of things to open.
 */
export function Link(props: { children: ReactNode; to?: string; href?: string; block?: boolean; label?: string }) {
  const className = cx(s.link, props.block && s.block)
  if (props.href) {
    return (
      <a className={className} href={props.href} target="_blank" rel="noreferrer" aria-label={props.label}>
        {props.children}
      </a>
    )
  }
  return (
    <RouterLink className={className} to={props.to ?? '/'} aria-label={props.label}>
      {props.children}
    </RouterLink>
  )
}
